import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrBrandBannerComponent } from './kn-br-brand-banner.component';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MediaModule,
    IconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CarlisleFooterCarouselComponent: {
          component: KnBrBrandBannerComponent,
        },
      },
    } as CmsConfig),
    KnBrBrandBannerComponent,
  ],
})
export class KnBrBrandBannerModule { }
